import { render, staticRenderFns } from "./dingdWxlist-up.vue?vue&type=template&id=8d7e0576"
import script from "./dingdWxlist-up.vue?vue&type=script&lang=js"
export * from "./dingdWxlist-up.vue?vue&type=script&lang=js"
import style0 from "./dingdWxlist-up.vue?vue&type=style&index=0&id=8d7e0576&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports